export enum LinkTarget {
  SameWindow = '_self',
  NewWindow = '_blank',
}
